import React from 'react'
import Modal from '@mui/material/Modal'

interface ModalProps {
  open: boolean
  onClose?: () => void
  disableEscapeKeyDown?: boolean
  children: React.ReactNode
}

export const BackdropClickModal: React.FC<ModalProps> = ({ open, onClose, disableEscapeKeyDown, children }) => {
  const handleModalClose = (event: Event, reason: string): void => {
    if (reason && reason === 'backdropClick') {
      return
    }
    onClose?.()
  }

  return (
    <Modal
      open={open}
      disableEscapeKeyDown={disableEscapeKeyDown}
      onClose={handleModalClose}
    >
      <div>{children}</div>
    </Modal>
  )
}
